module.exports = __webpack_public_path__ + "static/media/am_white.ac577cdd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/asset/am_white.svg
// module id = 968
// module chunks = 0